var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-navigation-drawer', {
    attrs: {
      "id": "app-drawer",
      "app": "",
      "floating": "",
      "persistent": "",
      "mobile-breakpoint": "1367",
      "width": "288"
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('LogoSection', {
    attrs: {
      "logo-image": _vm.logoImage
    }
  }), _c('v-divider'), _c('DrawerLinks', {
    attrs: {
      "links": _vm.links
    }
  }), _c('ModuleLinks', {
    attrs: {
      "modules": _vm.modules
    }
  })], 1), _c('v-divider', {
    staticClass: "mt-6"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }